/**
 * Line-icon path registry. Each entry is an array of `d` attributes drawn on a
 * 24x24 grid with a 1.7 stroke. Keep keys lowercase and semantic.
 */
export const ICON_PATHS = Object.freeze({
  requisition: ["M6 3h8l4 4v14H6z", "M9 12h6", "M9 16h4"],
  rfq: [
    "M6 3h8l4 4v14H6z",
    "M9 11h6",
    "M11.5 15.5a2 2 0 1 0 4 0 2 2 0 0 0-4 0",
    "M15.2 17.2 17 19",
  ],
  auction: ["M7 4v12", "M4 13l3 3 3-3", "M17 20V8", "M14 11l3-3 3 3"],
  contract: ["M6 3h8l4 4v14H6z", "M9 15l2 2 4-4"],
  po: [
    "M3 4h2l2.4 10.2a1 1 0 0 0 1 .8h8.2a1 1 0 0 0 1-.8L20 8H6",
    "M9 20a1 1 0 1 0 2 0 1 1 0 0 0-2 0",
    "M16 20a1 1 0 1 0 2 0 1 1 0 0 0-2 0",
  ],
  receipt: ["M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z", "M4 7.5l8 4.5 8-4.5", "M12 12v9"],
  invoice: ["M6 3h12v18l-3-2-3 2-3-2-3 2V3z", "M9 8h6", "M9 12h6"],
  analytics: ["M5 20V12", "M10 20V6", "M15 20v-5", "M20 20V9"],
  vendor: [
    "M12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    "M5 20c0-3.3 3.1-5.5 7-5.5s7 2.2 7 5.5",
  ],
  qualify: [
    "M12 3l2.2 1.6 2.7-.2.9 2.6 2.2 1.6-1 2.5 1 2.5-2.2 1.6-.9 2.6-2.7-.2L12 21l-2.2-1.6-2.7.2-.9-2.6L4 15.4l1-2.5-1-2.5 2.2-1.6.9-2.6 2.7.2L12 3z",
    "M9 12l2 2 4-4",
  ],
  onboard: [
    "M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    "M3 20c0-3.3 3.1-5.5 7-5.5 1.2 0 2.4.2 3.4.6",
    "M18 14v6",
    "M15 17h6",
  ],
  compliance: ["M12 3l7 3v6c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3z", "M9 12l2 2 4-4"],
  performance: ["M4 17l5-5 3 3 6-7", "M15 8h4v4"],
  shipping: [
    "M3 7h10v9H3z",
    "M13 10h4l3 3v3h-7",
    "M6.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    "M17 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  ],
  service: ["M9 4h6v3H9z", "M9 5.5H6v15h12v-15h-3", "M9 14l2 2 4-4"],
  overview: ["M4 4h7v7H4z", "M13 4h7v7h-7z", "M4 13h7v7H4z", "M13 13h7v7h-7z"],
  bulletin: ["M4 10v4h3l6 4V6l-6 4H4z", "M17 9a4 4 0 0 1 0 6"],
  suite: [
    "M12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    "M4 20c0-3.2 3-5.3 6.5-5.3",
    "M17 12l4 2.2v4.6L17 21l-4-2.2v-4.6L17 12z",
  ],
  certificate: [
    "M12 4l2 1.4 2.4-.2.8 2.3 2 1.4-.9 2.2.9 2.2-2 1.4-.8 2.3-2.4-.2L12 18l-2-1.4-2.4.2-.8-2.3-2-1.4.9-2.2-.9-2.2 2-1.4.8-2.3 2.4.2L12 4z",
    "M9.5 19.5 12 18l2.5 1.5",
  ],
  rating: ["M12 4l2.4 5 5.6.7-4 3.9 1 5.4-5-2.7-5 2.7 1-5.4-4-3.9 5.6-.7L12 4z"],
  builder: ["M4 4h7v7H4z", "M13 4h7v7h-7z", "M4 13h7v7H4z", "M16.5 13v7", "M13 16.5h7"],
  form: ["M5 4h14v16H5z", "M8 9h8", "M8 13h8", "M8 17h4"],
  workflow: ["M4 5h6v4H4z", "M14 15h6v4h-6z", "M7 9v6h7", "M14 11l3 4-3 4"],
  dashboard: ["M4 4h7v6H4z", "M13 4h7v10h-7z", "M4 12h7v8H4z", "M13 16h7v4h-7z"],
  ai: [
    "M12 4a4 4 0 0 1 4 4v8a4 4 0 0 1-8 0V8a4 4 0 0 1 4-4z",
    "M8 12h8",
    "M4 10h2",
    "M18 10h2",
    "M4 14h2",
    "M18 14h2",
  ],
  api: ["M9 15l6-6", "M10 6l1-1a3.5 3.5 0 1 1 5 5l-1 1", "M14 18l-1 1a3.5 3.5 0 1 1-5-5l1-1"],
  roles: ["M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", "M3 20c0-3 2.7-5 6-5s6 2 6 5", "M17 8v8", "M14 12h6"],
  security: ["M12 3l7 3v6c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3z", "M12 11v3"],
  transform: ["M4 12a8 8 0 0 1 13-6", "M20 12a8 8 0 0 1-13 6", "M17 3v3h-3", "M7 21v-3h3"],
  cases: ["M4 7h16v13H4z", "M9 7V4h6v3", "M9 13h6"],
  market: ["M4 8h16l-1.5 12h-13z", "M9 8V5a3 3 0 0 1 6 0v3"],
  supply: [
    "M3 17h5l3-10h5l2 4h3",
    "M6.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    "M17.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  ],
  integration: ["M9 15l6-6", "M10 6l1-1a3.5 3.5 0 1 1 5 5l-1 1", "M14 18l-1 1a3.5 3.5 0 1 1-5-5l1-1"],
  configure: ["M4 7h16", "M4 12h16", "M4 17h16", "M9 5v4", "M15 10v4", "M7 15v4"],
  match: ["M4 4h9v9H4z", "M11 11h9v9h-9z", "M6.5 8.5h4", "M13.5 15.5h4"],
  scan: ["M4 8V5h3", "M20 8V5h-3", "M4 16v3h3", "M20 16v3h-3", "M8 12h8"],
  check: ["M5 12.5l4.5 4.5L19 7"],
  globe: ["M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z", "M3 12h18", "M12 3c2.5 2.6 3.8 5.6 3.8 9S14.5 18.4 12 21c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z"],
  mail: ["M3 6h18v12H3z", "M3 7l9 6 9-6"],
  phone: ["M6 3h4l2 5-2.5 1.5a12 12 0 0 0 5 5L16 12l5 2v4a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4 5.2 2 2 0 0 1 6 3z"],
  clock: ["M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z", "M12 7v5l3.5 2"],
  spark: ["M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6z"],
});

/** Map a product/app name to its icon key. */
export const APP_ICON_KEYS = Object.freeze({
  "vendor onboarding": "onboard",
  "purchase requisition": "requisition",
  "request for quotation": "rfq",
  "contract management": "contract",
  "reverse / forward auction": "auction",
  "purchase order": "po",
  "purchase orders": "po",
  "e-auctions": "auction",
  "advance shipping notice": "shipping",
  invoice: "invoice",
  "goods receipt note": "receipt",
  "service entry sheet": "service",
  "supplier bulletin management": "bulletin",
  "supplier compliance management": "compliance",
  "supplier performance management": "performance",
  "supply chain issue management": "supply",
  "supplier certification": "certificate",
  "supplier rating": "rating",
  "low-code app builder": "builder",
  "form builder": "form",
  "workflow builder": "workflow",
  "dashboard & reports": "dashboard",
  analytics: "analytics",
  "ai engine": "ai",
  "api & integrations": "api",
  "role management": "roles",
  security: "security",
  "digital transformation": "transform",
  "workflow automation": "workflow",
  "case management": "cases",
  marketplace: "market",
  "procurement automation": "requisition",
  "vendor management": "vendor",
  "supply chain management": "supply",
});

export const TILES = Object.freeze([
  "#0F1D29",
  "#B4653A",
  "#3E5A55",
  "#8A5B7A",
  "#1F3A4D",
  "#A07C3F",
  "#2F4F6B",
  "#9E4A3C",
]);

export const iconKeyFor = (label) => APP_ICON_KEYS[String(label).toLowerCase()] ?? "overview";
